import { ThreadItem } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';
import { startOfDay } from 'date-fns';
import { groupBy } from '@frontend/array';

export const createThreadDateList = (items: ThreadItem[]): (string | ThreadItem)[] => {
  // Helper function to extract `createdAt` from any ThreadItem
  const getCreatedAt = (item: ThreadItem): string => {
    if ('smsMessage' in item) {
      return item.smsMessage.createdAt;
    } else if ('callRecord' in item) {
      return item.callRecord.startedAt ?? '';
    } else if ('aiActivity' in item) {
      return item.aiActivity.createdAt ?? '';
    }
    throw new Error('Unsupported ThreadItem type');
  };

  // Group items by the start of their `createdAt` day
  const groups = groupBy(items, (item) => startOfDay(new Date(getCreatedAt(item))).toISOString());

  // Build the date list
  const dateList = Object.entries(groups).reduce<(string | ThreadItem)[]>((acc, [date, items]) => {
    acc.push(date);
    items.forEach((item) => acc.push(item));

    return acc;
  }, []);

  return dateList;
};
